module.exports = __webpack_public_path__ + "media/images/signin-f01e1ebb32e378c4ab385114978b56dc.png";